export default __webpack_public_path__ + "static/media/detail1.01a16dd4.svg";